import {
  CellWrapper,
  DisabledTag
} from '@nile/mangifera/src/Pebbles/TaskViewContainer';
import { Link } from '@superops/ui-design-system';
import { NewTask, Loader } from '@nile/components';
import React, { useState } from 'react';
import { useQuery } from '@apollo/client';
import { useHistory, useLocation } from 'react-router-dom';
import { GET_TASK } from '@nile/graphql/src';
import { useCheckIsItProduct } from '@nile/components/src/Utils/helpers';

function HTMLCell(props) {
  const { cell, action } = props;
  const [sheetActive, setSheetActive] = useState(false);

  const toggleSheetActive = () => {
    setSheetActive(!sheetActive);
  };
  const { actions } = cell.column;
  const value = props.column.subAccessor
    ? cell.value[props.column.subAccessor]
    : cell.value;
  const updateTaskHandler = (ut, updatedTask) => {
    actions.updateTask(
      updatedTask,
      cell?.row?.original?.taskId,
      cell?.row?.original,
      toggleSheetActive
    );
  };
  const onDeleteHandler = () => {
    actions.deleteTask(
      cell?.row?.original?.taskId,
      cell?.row?.original,
      toggleSheetActive
    );
  };
  /* revisit dangerouslySetInnerHTML xss  */
  return value ? (
    <CellWrapper>
      <Link removeUnderline>
        <NewTask
          addOrUpdateTechGroup={updateTaskHandler}
          state={sheetActive}
          toggleSheetActive={toggleSheetActive}
          name={value}
          hideIcon
          isLink
          data={cell?.row?.original}
          module={cell?.row?.original?.project ? 'PROJECT_TASK' : 'TICKET_TASK'}
          details={
            props?.data?.taskId
              ? cell?.row?.original?.project
                ? {
                    operation: 'UPDATE',
                    taskId: cell?.row?.original?.taskId,
                    projectId: cell?.row?.original?.project?.projectId
                  }
                : {
                    operation: 'UPDATE',
                    taskId: cell?.row?.original?.taskId,
                    ticketId: cell?.row?.original?.ticket?.ticketId
                  }
              : cell?.row?.original?.project
              ? {
                  operation: 'CREATE',
                  projectId: cell?.row?.original?.project?.projectId
                }
              : {
                  operation: 'CREATE',
                  ticketId: cell?.row?.original?.ticket?.ticketId
                }
          }
          showParent
          onDeleteHandler={onDeleteHandler}
          locked
        />
      </Link>
    </CellWrapper>
  ) : (
    <DisabledTag>NA</DisabledTag>
  );
}

export default HTMLCell;

export function NewTaskModal(props) {
  const { taskId, module, actions } = props;
  const isItProduct = useCheckIsItProduct();
  const { loading, data, error } = useQuery(GET_TASK, {
    variables: {
      taskId,
      module,
      isItProduct
    },
    fetchPolicy: 'network-only'
  });
  const history = useHistory();
  const location = useLocation();
  const [sheetActive, setSheetActive] = useState(true);

  if (loading) {
    return <Loader />;
  }

  const taskData = data?.getTask;

  const toggleSheetActive = () => {
    const { pathname } = location;
    history.replace(pathname);
    setSheetActive(!sheetActive);
  };
  const value = taskData.title;
  const updateTaskHandler = (ut, updatedTask) => {
    actions.updateTask(
      updatedTask,
      taskData?.taskId,
      taskData,
      toggleSheetActive
    );
  };
  const onDeleteHandler = () => {
    actions.deleteTask(taskData?.taskId, taskData, toggleSheetActive);
  };

  return (
    <NewTask
      addOrUpdateTechGroup={updateTaskHandler}
      state={sheetActive}
      toggleSheetActive={toggleSheetActive}
      name={value}
      hideIcon
      isLink
      data={taskData}
      module={taskData?.project ? 'PROJECT_TASK' : 'TICKET_TASK'}
      details={
        props?.data?.taskId
          ? taskData?.project
            ? {
                operation: 'UPDATE',
                taskId: taskData?.taskId,
                projectId: taskData?.project?.projectId
              }
            : {
                operation: 'UPDATE',
                taskId: taskData?.taskId,
                ticketId: taskData?.ticket?.ticketId
              }
          : taskData?.project
          ? {
              operation: 'CREATE',
              projectId: taskData?.project?.projectId
            }
          : {
              operation: 'CREATE',
              ticketId: taskData?.ticket?.ticketId
            }
      }
      showParent
      onDeleteHandler={onDeleteHandler}
    />
  );
}
